export const ANALYTICS_DASHBOARD_URL_EXPIRATION = 600; // 10 minute expiration in seconds
export const ANALYTICS_DASHBOARD_BASE_URL = 'https://dotfile.metabaseapp.com';
